import { render } from "./updating-firmware.md?vue&type=template&id=9b183c10"
import script from "./updating-firmware.md?vue&type=script&lang=js"
export * from "./updating-firmware.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__